module.exports = __webpack_public_path__ + "images/04882f71808f97ea058b900e81a7fb01.png";